/**
 * 供应链管理模块 - 背景图上的可点击坐标点配置（图2风格）
 * 坐标使用百分比定位，适配不同分辨率
 */
export interface SupplyChainMapPoint {
  id: string;
  name: string;
  description: string;
  /** 定位：水平百分比 0-100 */
  left: number;
  /** 定位：垂直百分比 0-100 */
  top: number;
  /** 跳转路径 */
  path: string;
  /** 标记点颜色：blue | green | orange */
  pinColor: 'blue' | 'green' | 'orange';
}

export const supplyChainMapPoints: SupplyChainMapPoint[] = [
  {
    id: 'plm',
    name: 'PLM 系统(Centric)',
    description: '产品研发全生命周期管理',
    left: 43,
    top: 25,
    path: 'https://plm.shjinjia.com.cn/WebAccess/login.html',
    pinColor: 'blue',
  },
  {
    id: 'srm',
    name: 'SRM 系统(甄云)',
    description: '供应商关系管理系统',
    left: 70,
    top: 15,
    path: 'https://jinjia-srm.going-link.com',
    pinColor: 'green',
  },
  {
    id: 'ms',
    name: 'OMS 系统(旺店通)',
    description: '订单管理系统',
    left: 70,
    top: 50,
    path: 'http://101.34.21.114:8088/gids/index.html#/login',
    pinColor: 'orange',
  },
  {
    id: 'nc',
    name: 'NC 系统',
    description: '财务和供应链管理系统',
    left: 52,
    top: 50,
    path: ' https://oak.shjinjia.com.cn/',
    pinColor: 'green',
  },
];
